<template>
  <li class="timer">
    <i>{{ emoji.time.image }}</i>
    <span>{{ emoji.time.desc }}</span>
    <span>{{ countTime }}</span>
  </li>
</template>

<script>
import { mapState } from 'vuex'
import { emoji } from '../../const'

export default {
  name: 'Timer',
  data () {
    return {
      emoji,
    }
  },
  computed: {
    ...mapState(['countTime'])
  }
}
</script>
<style lang="scss" scoped>
.timer {
  border-top: 2px dashed gray;
  padding-top: 10px;
}
</style>